<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{successMessage}}</span>
	<a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="row bg-white rounded-top border-chn">
	<div class="col-md-7 my-2">
		<div class="text mt-1" style="font-weight: 500;font-size: 14px">
			Select Files to Assign OR 
		</div> 
		
	</div>
	<div class="col-md-1">
		
	</div>
	<div class="col-md-4 my-2">
		<button class="btn  btn-up btn-sm" data-target="#uploadModal" data-toggle="modal">Upload<img src="./assets/img/download-new.svg" class="ml-2"></button>
		
	</div>
			
</div>
<div class="row" style="background: #e9e9e9;">
	<div class="col-md-12" *ngIf="file_type && file_type.length > 0" style="height: 322px;overflow-y: scroll;">
			<div class="row px-2 my-3">
				
				<div class="col-md-12 my-1" *ngFor="let item of file_type">
					<button class="btn btn-yel my-3">{{ changeFileFormat(item) }}</button><br>

					<ng-container *ngFor="let obj of file_list[item];let i = index">
						<input type="checkbox" class="d-none" [checked]="obj.checked" id=obj{{obj.id}}>
						<button class="btn  btn-ups btn-sm pl-3 {{ obj.id }}  my-1" (click)="selectFiles(obj,i)">{{ obj.name }}</button><br>
					</ng-container>	
					
				</div>
				
				
			</div>
		
	</div>
	<div class="col-md-12 bg-white" *ngIf="file_type && file_type.length == 0" style="    border-top: 2px solid #ECF0F1;
        border-bottom: 2px solid #ECF0F1;;height: 322px">
		<div class="boq-img text-center" style="margin-top: 9.5rem">
           <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">No Files Uploaded...</p>        
        </div>
        

		
	</div>
	
</div>
<div class="row bg-white rounded-bottom bg-change-row">
	<div class="col-md-6 text-center my-3">
		<button class="btn   btn-assign" (click)="assignToLineItem('assign')">Assign</button>
		
	</div>
	<div class="col-md-6 text-center my-3">
		<button class="btn  btn-up-chng"  (click)="assignToLineItem('no_need')" style="font-size: 10px;">No Production Drawing Needed</button>
		
	</div>
	
</div>
<!-- CREATE CAD MODAL -->
<div class="modal fade" id="uploadModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-chng px-5" style="border-bottom: 1px solid #e4e4e4;">
        <h6 class="modal-title mt-3" id="exampleModalLabel" style="font-size: 22px">Upload a  file  </h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="./assets/img/handover/cross-btn.svg"></span>
        </button>
      </div>
      <div class="modal-body px-5">
        <div class="row">
          <div class="col-md-12">
            <form (ngSubmit)="onSubmit(createUploadForm.value); createUploadForm.reset()" #createUploadForm="ngForm" class="form-horizontal" enctype="multipart/form-data">
              <div class="form-group">
              	<label class="form-check-label boq-link ml-3 mb-2" *ngFor="let item of categoryList">
                  <ng-container>
                    <input class="form-check-input" type="radio"   value="{{ item }}" name="file_type" ngModel #file_type="ngModel" id="file_type" (change)="selectReviseList(item)">
                     {{ item | replaceChar}}
                  </ng-container>
                  
                </label>
                <label for="name" class="ss-form-label">File Name</label>
                <input type="text" class="form-control " id="name" placeholder="A proper name for  file" required name="name" #name="ngModel" ngModel>

                <label for="upload_file" class="ss-form-label mt-4">Upload File</label>
                <input type="file" class="form-control " (change)="onChange($event)" name="upload_file" ngModel #upload_file="ngModel" id="upload_file">

                <button type="submit" class="btn btn-pink button_emi mx-auto d-block mt-4" [disabled]="!createUploadForm.valid || basefile == undefined || selected_file_type == undefined "> Submit </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/category/category/assign-files-category/assign-files-category.component.html